import React, {
    useEffect,
    useState,
} from 'react';

import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import values from 'lodash/values';

import { capitalizeFirstLetter } from '../../helpers/stringUtils';

interface FilterItemData {
    id: string;
    name: string;
    selected: boolean;
}

export interface FilterItemProps {
    key?: string;
    data: FilterItemData[];
    name: string;
    label: string;
    value?: any;
    reset?: boolean;
    sort?: string;
    limitBy?: string;
    limitKey?: string;
    limitValue?: string;
    onChange?: (key: string, value: any, limit?: any) => void;
}

const FilterItem: React.FC<FilterItemProps> = ({ data, name, label, value, sort = null, reset = false, limitBy = null, limitKey = null, limitValue = null, onChange }) => {
    const [val, setVal] = useState(value);

    useEffect(() => {
        setVal(value);
    }, [value]);

    useEffect(() => {
        if (value !== val) {
            setVal(value);
        }
    }, [reset]);

    const handleFilterChange = e => {
        const inputVal = e.currentTarget.value;
        setVal(inputVal);

        let limitedValue = null;

        if (limitKey) {
            const item = filter(values(data), o => o.id.toString() === inputVal);

            if (item.length === 1) {
                limitedValue = item[0][limitKey];
            }
        }

        if (onChange) {
            onChange(name, inputVal, limitedValue);
        }
    };

    const getData = () => {
        const all = filter(values(data), o => o.id === 'all');
        const unassigned = filter(values(data), o => o.id === 'unassigned');
        let options = filter(values(data), o => o.id !== 'all' && o.id !== 'unassigned');

        if (limitBy && limitValue) {
            options = filter(options, o => {
                return (o[limitBy] === null) ? o : (limitBy === 'outlet' && o[limitBy]) ? (o[limitBy].indexOf(limitValue) > -1) : o[limitBy].toString() === limitValue.toString();
            });
        }

        if (sort) {
            options = sortBy(filter(options, o => o.id !== 'all' && o.id !== 'unassigned'), [sort]);
        }

        if (all.length > 0 && unassigned.length > 0) {
            return [...all, ...unassigned, ...options];
        }

        return all.length > 0 ? [...all, ...options] : options;
    };

    return (
        <div className="sl__filter__group">
            <label>{label}</label>
            <select name={name} value={val} onChange={handleFilterChange}>
                {getData().map(row => (
                    <option key={row.id} value={row.sales_rep_id || row.id}>{capitalizeFirstLetter(row.name)}</option>
                ))}
            </select>
        </div>
    );
};

export default FilterItem;



// WEBPACK FOOTER //
// ./src/sections/SmartList/FilterItem.tsx